import { type FC, useContext } from "react";

import { Container } from "@snapchat/snap-design-system";
import { Form } from "formik";

import { API, ENDPOINTS } from "../../../api/util";
import { ApisContext } from "../../../context";
import { ApiEdit } from "../../common/api-settings/ApiEdit";
import { EndpointsEdit } from "../../common/endpoints";

import { CreateApiFormEula } from "./CreateApiFormEula";

interface CreateApiFormProps {
    onSubmit: () => Promise<void>;
}

export const CreateApiForm: FC<CreateApiFormProps> = ({ onSubmit }) => {
    const { step, agreement, setAgreement } = useContext(ApisContext);

    return (
        <Form
            data-testid="remote-api-form"
            onSubmit={() => {
                void onSubmit();
            }}
        >
            {step === API && <ApiEdit />}
            {step === ENDPOINTS && (
                <Container>
                    <EndpointsEdit />
                    <CreateApiFormEula agreement={agreement} setAgreement={setAgreement} />
                </Container>
            )}
        </Form>
    );
};
